module.exports = __webpack_public_path__ + "img/1745577907_XQ8R.3e7c0c6f.jpg";